import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import OverlaySpinner from './spinners/OverlaySpinner';

const useStyles = makeStyles({
  dialogContent: {
    height: 'auto',
  },
});

interface ConfirmDialogProps {
  isOpen?: boolean;
  isLoading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  title: string;
  text: string;
  confirmButtonText: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
  title,
  text,
  confirmButtonText,
}) => {
  const classes = useStyles();
  const { t } = useTranslation(['translations']);
  return (
    <Dialog open={isOpen === true} onClose={onCancel}>
      <OverlaySpinner isLoading={!!isLoading}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary">
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} color="primary" autoFocus>
            {confirmButtonText}
          </Button>
        </DialogActions>
      </OverlaySpinner>
    </Dialog>
  );
};

export default ConfirmDialog;
